module.exports = __webpack_public_path__ + "media/images/fill@2x-9c49fff5dd6ab1412a5d1ad2c4b174f9.png";